import '@css/bestcosme/common.scss'
import '@css/bestcosme/2025.scss'

$(function () {
  // $('.anchor_link').click(function (event) {
  //   event.preventDefault();
  //   $('html, body').animate({
  //     scrollTop: $($.attr(this, 'href')).offset().top
  //   }, 500, 'swing');
  // });

  // main page top slider
  let grand_slider_owl = $('#grand_owl_carousel .js_grand_owl_carousel').owlCarousel({
    items: 1,
    loop: true,
    dots: false,
    // autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: true
  });
  $("#grand_owl_carousel .slidesjs-next").click(function () {
    grand_slider_owl.trigger('next.owl.carousel');
  });
  $("#grand_owl_carousel .slidesjs-previous").click(function () {
    grand_slider_owl.trigger('prev.owl.carousel', [300]);
  });

  let down_newstar_slider_owl = $('#down_newstar_owl_carousel .js_down_newstar_owl_carousel').owlCarousel({
    loop: true,
    margin: 0,
    nav: false,
    dots: false,
    center: true,
    // autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    items: 3
  });
  $("#down_newstar_owl_carousel .slidesjs-next").click(function () {
    down_newstar_slider_owl.trigger('next.owl.carousel');
  });
  $("#down_newstar_owl_carousel .slidesjs-previous").click(function () {
    down_newstar_slider_owl.trigger('prev.owl.carousel', [300]);
  });

  // 使用 Intersection Observer 監測元素是否進入視口
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.8 // 當 80% 的元素進入視口時觸發
  };

  const carouselConfigs = [
    { element: $('.js_grand_owl_carousel'), owl: grand_slider_owl, timeout: 4000 },
    // { element: $('#hall_slider_items'), owl: hall_slider_owl, timeout: 4000 },
    // { element: $('#down_newstar_slider_items'), owl: down_newstar_slider_owl, timeout: 4000 },
    // { element: $('#tw_jp_slider_items'), owl: tw_jp_slider_owl, timeout: 4000 }
  ];

  const observerCallback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const config = carouselConfigs.find(c => c.element[0] === entry.target);
        if (config && config.owl) {
          // 開始 autoplay
          config.owl.trigger('play.owl.autoplay', [config.timeout]);
          // 只需要啟動一次，所以停止觀察
          observer.unobserve(entry.target);
        }
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  // 觀察所有輪播元素
  carouselConfigs.forEach(config => {
    if (config.element.length > 0) {
      observer.observe(config.element[0]);
    }
  });

  // 2025 大賞每日登入任務
  // 當區塊進入可視範圍時，將 today 項目滾動到正中間
  const todayItem = $('.daily-login-task-item.today');
  const dailyLoginContainer = $('.daily-login-tasks-container');
  
  if (todayItem.length > 0 && dailyLoginContainer.length > 0) {
    const dailyLoginObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 當區塊進入可視範圍時，將 today 項目置中
          todayItem[0].scrollIntoView({
            behavior: 'auto',
            block: 'nearest',
            inline: 'center'
          });
          // 只需要執行一次，停止觀察
          dailyLoginObserver.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.3 // 當 30% 的區塊進入視口時觸發
    });
    
    dailyLoginObserver.observe(dailyLoginContainer[0]);
  }

  $('.daily-login-task-item.today').on('click', function() {
    $('#qa_modal').removeClass('hidden');
  });
  
  $('.close_modal').on('click', function() {
    $('#qa_modal').addClass('hidden');
  });

  function showMessageAlert(message) {
    $('#message_alert').removeClass('hidden');
    $('#message_alert .message-alert-text').text(message);
  }

  $('.submit_btn').on('click', function() {
    const qa_id = $('#qa_id').val();
    const user_id = $('#user_id').val();
    const answer = $('#answer').val();
    if (!qa_id || !user_id || !answer) {
      return;
    }
    $.ajax({
      url: '/activities/create_daily_qa',
      type: 'POST',
      data: {
        qa_id: qa_id,
        user_id: user_id,
        answer: answer
      },
      success: function(data) {
        $('#qa_modal').addClass('hidden');
        showMessageAlert(data.message);
      },
      error: function(xhr, status, error) {
        console.log(xhr.responseText);
      }
    });
  });

  $('.close_message_alert').on('click', function() {
    $('#message_alert').addClass('hidden');
  });


}); 
